module.exports = __webpack_public_path__ + "static/media/logo_bundesministerium.d554b2dc.svg";